import { useAnotherApp, useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';
import EmbeddedStatusScreen from '../shared/StatusScreen';

/** The request expired with no QR code on screen: a clock and Try again. */
export default function EmbeddedTimeoutScreen({
  onRetry,
  onBack,
}: {
  onRetry: () => void;
  onBack?: () => void;
}) {
  const { t } = useEmbeddedCopy();
  return (
    <EmbeddedStatusScreen
      visual="clock"
      title={t('embedded.timeout.title')}
      sub={t('embedded.timeout.sub')}
      primary={{ label: t('embedded.tryAgain'), onClick: onRetry }}
      secondary={useAnotherApp(onBack)}
    />
  );
}
